<template>
  <a-modal
    title="订单详情"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :footer="false"
    @cancel="handleCancel"
    v-if="hackReset"
  >
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('inquiryorder:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="提交时间">
                <a-date-picker style="width: 100%" placeholder="请选择提交时间" @change="onChangectstamp"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="费用类型">
                <!-- <a-input v-model="queryParam.orderType" allow-clear placeholder="请输入订单类型"/> -->
                <a-select v-model="queryParam.businessType"  allow-clear placeholder="请选择费用类型" :options="businessType"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付状态">
                <!-- <a-input v-model="queryParam.orderType" allow-clear placeholder="请输入订单类型"/> -->
                <a-select v-model="queryParam.tradeState"  allow-clear placeholder="请选择支付状态" :options="tradeState"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.businessId"
        :rowSelection="options.rowSelection"
      > 
        <span slot="orderType" slot-scope="text, record">
            {{record.orderType == '0'? '挂号费' : record.orderType == '1'? '医药费' : record.orderType == '2'? '护理费' : '' }}
        </span>
        <span slot="tradeState" slot-scope="text, record">
            {{record.tradeState == '0'? '未交易' : record.tradeState == '1'? '交易中' : record.tradeState == '2'? '交易成功' :  record.tradeState == '3'? '交易失败 ' : '' }}
        </span>
        <span slot="tradepChannels" slot-scope="text, record">
            {{record.tradepChannels == '01'? '支付宝' : record.tradepChannels == '02'? '微信' : record.tradepChannels == '03'? '银行卡' : record.tradepChannels == '04'? '免费' : ''  }}
        </span>

        <span slot="action"  slot-scope="text, record">
          <a @click="$refs.addForm.add(record)">详情</a>
        </span>
      </s-table>
      <add-form ref="addForm" />
    </a-card>
  </a-modal>
</template>

<script>
  import { STable } from '@/components'
  import moment from 'moment'
  import { recipeDetial } from '@/api/modular/interhospital/checkout/checkoutManage'
  export default {
     components: {
      STable,
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        birthdayDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        parameter : {},
        userDate : '',
        hackReset : true,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '交易时间',
            align: 'center',
            dataIndex: 'tradeTime'
          },
          {
            title: '订单编号',
            align: 'center',
            dataIndex: 'orderId'
          },
          {
            title: '业务类型',
            align: 'center',
            dataIndex: 'orderType',
            scopedSlots: { customRender: 'orderType' },
          },
          {
            title: '患者',
            align: 'center',
            dataIndex: 'patientName'
          },
          {
            title: '科室',
            align: 'center',
            dataIndex: 'deptName',
          },
          {
            title: '金额(元)',
            align: 'center',
            dataIndex: 'feeAll',
          },
          {
            title: '交易状态',
            align: 'center',
            dataIndex: 'tradeState',
            scopedSlots: { customRender: 'tradeState' },
          },
          {
            title: '支付渠道',
            align: 'center',
            dataIndex: 'tradepChannels',
            scopedSlots: { customRender: 'tradepChannels' },
          },
          {
            title: '流水号',
            align: 'center',
            dataIndex: 'tradeId',
          },
          // {
          //   title: '交易失败原因',
          //   align: 'center',
          //   dataIndex: 'deptname'
          // },
        ],
        businessType : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '挂号费',
          },
          {
            value: '1',
            label: '医药费',
          },
          {
            value: '2',
            label: '护理费',
          },
        ],
        tradeState : [
          {
            value: '1',
            label: '付费',
          },
          {
            value: '2',
            label: '退费',
          },
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return recipeDetial(Object.assign(parameter, this.queryParam)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
   
    methods: {
      // 初始化方法
      add (record) {
        this.queryParam.id = record.id;
        // console.log('record--------',record.id);
        // this.parameter.id = record.id;
        // this.parameter.pageNo = 1;
        // this.parameter.pageSize = 100;
        this.visible = true;
        // recipeDetial(this.parameter).then(res=>{
        //   this.userDate = res.data;
        //   console.log(this.userDate)
        // });
      },
      onChangectstamp(date, dateString) {
        this.queryParam.tradeTime = dateString;
      },
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },

      
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less" scoped>
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
/deep/.s-table-tool{
  display: none;
}
</style>
